export const pwaAssets = {
	bannerIcon: "/spec_pwa/banner-icon.png",
	infoStep1Android: "/spec_pwa/info-step1-android.png",
	infoStep1Ios: "/spec_pwa/info-step1-ios.png",
	infoStep2Android: "/spec_pwa/info-step2-android.png",
	infoStep2Ios: "/spec_pwa/info-step2-ios.png",
	infoStep3: "/spec_pwa/info-step3.png",
	pushBannerIcon: "/spec_pwa/push-banner-icon.png",
	pushInfoBackground: "/spec_pwa/push-info-bg.jpg",
	pushInfoBackgroundLandscape: "/spec_pwa/push-info-bg-landscape.jpg",
	pushPermissionsBackground: "/spec_pwa/push-permissions-bg.jpg",
	rewardPopupBackground: "/spec_pwa/reward-popup-bg.png"
} as const;
